import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import {
  UrlSerializer,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { TrailingSlashUrlSerializer } from './core/trailing-slash-url-serializer';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      // 'enabled', not 'top': new pages still open at the top, but Back returns to
      // where you were. The home page's booking sheet relies on that, since closing
      // it is a Back navigation and must not jump the page to the top.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
    // Keeps the trailing slashes the old site was indexed under.
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    provideHttpClient(withFetch()),
  ],
};
